import format from "string-template";
import { REGEX_EXPS } from "utils/constants";
import { normalizeTextField, stripAllSpaces } from "utils/helpers/validations";
import * as yup from "yup";

function requiredIfOtherAccount(value) {
  const root = this.from?.[this.from.length - 1]?.value;
  if (root?.isPayerReceiver === false)
    return typeof value === "string" ? value.trim().length > 0 : value != null;
  return true;
}

const validation = (messages) => {
  const string = yup
    .string()
    .typeError(messages.NOT_STRING)
    .required(messages.REQUIRED)
    .nullable();
  const noSpaceString = yup.string().transform(stripAllSpaces);
  const nameValidation = yup
    .string()
    .transform(normalizeTextField)
    .typeError(messages.NOT_STRING)
    .nullable()
    .notRequired()
    .test(
      "is-valid-name",
      messages.INVALID_NAME,
      (value) => !value || REGEX_EXPS.name.test(value),
    );
  return yup.object().shape({
    payment: yup.object().shape({
      type: string,
      frequency: string,
      debitDay: string,
      payer: yup.object().shape({
        BIC: noSpaceString
          .typeError(messages.NOT_STRING)
          .required(messages.REQUIRED)
          .nullable(),
        IBAN: noSpaceString
          .typeError(messages.NOT_STRING)
          .required(messages.REQUIRED)
          .max(34, format(messages.MAX_LENGTH, { length: 34 }))
          .matches(
            /^(fr|cz|nl)/i,
            format(messages.INVALID_PREFIX, { prefixes: '"FR", "CZ" or "NL"' }),
          )
          .nullable(),
        owner: yup.object().shape({
          isAdherent: yup.boolean().typeError(messages.NOT_BOOLEAN),
          firstName: nameValidation,
          lastName: nameValidation,
        }),
      }),
      receiver: yup.object().shape({
        BIC: noSpaceString
          .typeError(messages.NOT_STRING)
          .required(messages.REQUIRED)
          .nullable(),
        IBAN: noSpaceString
          .typeError(messages.NOT_STRING)
          .required(messages.REQUIRED)
          .max(34, format(messages.MAX_LENGTH, { length: 34 }))
          .matches(
            /^(fr|cz|nl)/i,
            format(messages.INVALID_PREFIX, { prefixes: '"FR", "CZ" or "NL"' }),
          )
          .nullable(),
        owner: yup.object().shape({
          firstName: nameValidation.test(
            "required-other-account",
            messages.REQUIRED,
            requiredIfOtherAccount,
          ),
          lastName: nameValidation.test(
            "required-other-account",
            messages.REQUIRED,
            requiredIfOtherAccount,
          ),
        }),
      }),
    }),
  });
};

export default validation;
